import React from "react";
import { styled } from "../../stitches.config";


const SpecialDaysCounterTimer = props => {
  const { article } = props;

  return (
    <Timer>
      {article.number && <span>{article.number}.</span>}
      {article.text ? <p>{article.text}</p> : <p>dzień wojny w Ukrainie</p>}
    </Timer>

  );
}


const Timer = styled("div", {
  backgroundColor: "#131212",
  color: "#ff6000",
  display: "flex",
  width: "100%",
  flexShrink: 0,
  textAlign: "center",
  fontWeight: "bold",
  justifyContent: "center",
  alignItems: "flex-end",
  paddingBottom: "6px",
  paddingTop: "8px",
  "@media (min-width: 992px)": {
    alignItems: "center",
    width: "270px",
    height: "100%",
    flexDirection: "column",
    padding: "10px"
  },
  "span": {
    fontSize: "36px",
    textAlign: "center",
    margin: "0 10px -6px 0",
    "@media (min-width: 992px)": {
      width: "100%"
    }
  },
  "p": {
    margin: "0",
    fontSize: "20px",
    color: "white",
    "@media (min-width: 992px)": {
      fontSize: "16px"
    }
  }
});

export default SpecialDaysCounterTimer